<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsTeam')}}
												</label>
												<select v-model="instance.prsTeam" class="form-control" multiple>
													<option v-for="prsTeam in prsTeamList" :value="prsTeam.id" :key="prsTeam.id">
													{{ prsTeam.lib}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servType')}}
												</label>
												<select v-model="instance.servType" class="form-control" multiple>
													<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id">
													{{ servType.typeName}}
													</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.username')}}
												</label>
												<select v-model="instance.username" class="form-control" multiple>
													<option v-for="user in userList" :value="user" :key="user">
														{{ user}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>

									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

									<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<div class="datatable">
							<datatable-instance :instanceClassAttr="instanceClassAttr" ref="componentDatatableInstance"/>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>

		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	// import modalScriptMixin from "@/mixins/modalScriptMixin";
	export default {
		name: 'servTeam',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('servteam.label'),
				pageTitle: this.$t('servteam.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'servteam',
					routerShow: 'servteamshow',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true,
						// actAlign: 'right',
						thCol: '7%', 
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: true, 
						actPrint: 'reportlist'
					},
					attrsList: [
						{attrName: 'prsTeamLib', attrCol: '23%', searchable: false, sortable: true},
						{attrName: 'servDate', attrCol: '10%', searchable: false, sortable: true},
						// {attrName: 'servTypeLib', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'servOp', attrCol: '50', searchable: false, sortable: true},
						{attrName: 'usernameLib', attrCol: '10%', searchable: true, sortable: false, attrRep: ''}
					]
				},

				instance: {},
				prsTeamList: [],
				userList: [],
				servTypeList: []
					
			}
		},
		async mounted () {
			this.$store.dispatch('loading')
			this.$nextTick(() => {
				this.$store.dispatch('unloading')
			})
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsteam'
				})
				.then(response => {
					this.prsTeamList = response.data
				})
				.catch(error => {
					console.log('error catch prsTeamList == ', error.message)
				})
				// GET LIST user
				await this.$store.dispatch('axiosGet', {
					domain: 'user'
				})
				.then(response => {
					response.data.forEach(element => {
						this.userList.push(element.username)
					});
				})
				.catch(error => {
					console.log('error catch userList == ', error.message)
				})
				
				// GET LIST servTypeList
				await this.$store.dispatch('axiosGet', {
					domain: 'servtype'
				})
				.then(response => {
					this.servTypeList = response.data
				})
				.catch(error => {
					console.log('error catch servTypeList == ', error.message)
				})
			}
			this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					prsTeam: [],
					username: [],
					servType: [],
					dateEntryAfter:'',
					dateEntryBefore:''
				};
			},
			async search() {
				let strParamsForms = "";
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';
				// Date super
				strParamsForms = strParamsForms+"&params1=servDate&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Date inf
				strParamsForms = strParamsForms+"&params2=servDate&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}
				strParamsForms = strParamsForms+"&params3=prsTeam.id&valParams3="+this.instance.prsTeam +"&logParams3=inL"
				if(this.instance.prsTeam && this.instance.prsTeam.length >0 ){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsTeamList, this.instance.prsTeam, 'lib')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsTeam')+'(s) : </i><b>'+strLibs + '</b>'
				}
				// strParamsForms = strParamsForms+"&params4=servType.id&valParams4="+this.instance.servType +"&logParams4=inL"

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				strParamsForms = strParamsForms+"&params5=username&valParams5="+this.instance.username +"&logParams5=inS"
				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
		}
		
	}

</script>